import React from "react";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import Container from "@material-ui/core/Container";
import ApplicationHeader from "../application/ApplicationHeader";
import ApplicationPanel from "../application/ApplicationPanel";

import Organize from "./organize/Organize";
import CollectionView from "./collections/CollectionView";
import ContentView from "./content/ContentView";
import AnthologyView from "./anthologies/AnthologyView";
import ModuleView from "./modules/ModuleView";

import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { CreatorProvider } from "./CreatorContext";
import withAuthorization from "../auth/withAuthorization";
import DashboardView from "./dashboard/DashboardView";
import CreatorNavigation from "./CreatorNavigation";
import UploadMedia from "./organize/upload/UploadMedia";

// MAC Table
import ManageContentAccess from "./content/edit/ManageContentAccess";
import ManageModuleAccess from "./modules/edit/ManageModuleAccess";
import ManageCollectionAccess from "./collections/edit/ManageCollectionAccess";

export const creatorRoles = [
  "ROLE_ADMIN",
  "ROLE_CREATOR_MANAGER",
  "ROLE_CREATOR_USER",
  "ROLE_CONTENT_MANAGER",
];

const AuthorizedRoute = withAuthorization(Route, true);

const CreatorApplication = () => {
  const { path } = useRouteMatch();

  return (
    <CreatorProvider>
      <DndProvider backend={HTML5Backend}>
        <Container id="creator-application" disableGutters>
          <ApplicationHeader applicationNavigation={<CreatorNavigation />} />

          <Switch>
            <AuthorizedRoute path={`${path}/home`} roles={creatorRoles}>
              <ApplicationPanel id="application-panel-dashboard">
                <DashboardView />
              </ApplicationPanel>
            </AuthorizedRoute>
            <AuthorizedRoute path={`${path}/organize`} roles={creatorRoles}>
              <Organize />
            </AuthorizedRoute>
            <AuthorizedRoute path={`${path}/upload`} roles={creatorRoles}>
              <UploadMedia />
            </AuthorizedRoute>
            <AuthorizedRoute path={`${path}/anthologies`} roles={creatorRoles}>
              <ApplicationPanel
                id="application-panel-anthologies"
                background="white"
              >
                <AnthologyView />
              </ApplicationPanel>
            </AuthorizedRoute>
            <AuthorizedRoute
              path={`${path}/manage-access/module/:id`}
              roles={["ROLE_ADMIN"]}
            >
              <ManageModuleAccess />
            </AuthorizedRoute>
            <AuthorizedRoute
              path={`${path}/manage-access/collection/:id`}
              roles={["ROLE_ADMIN"]}
            >
              <ManageCollectionAccess />
            </AuthorizedRoute>
            <AuthorizedRoute
              path={`${path}/manage-access/content/:id`}
              roles={["ROLE_ADMIN"]}
            >
              <ManageContentAccess />
            </AuthorizedRoute>
            <AuthorizedRoute path={`${path}/content`} roles={creatorRoles}>
              <ApplicationPanel
                id="application-panel-content"
                background="white"
              >
                <ContentView />
              </ApplicationPanel>
            </AuthorizedRoute>
            <AuthorizedRoute path={`${path}/collections`} roles={creatorRoles}>
              <ApplicationPanel
                id="application-panel-collections"
                background="white"
              >
                <CollectionView />
              </ApplicationPanel>
            </AuthorizedRoute>
            <AuthorizedRoute path={`${path}/modules`} roles={creatorRoles}>
              <ApplicationPanel
                id="application-panel-modules"
                background="white"
              >
                <ModuleView />
              </ApplicationPanel>
            </AuthorizedRoute>
            <Route path={path} exact>
              <Redirect to={`${path}/home`} />
            </Route>
          </Switch>
        </Container>
      </DndProvider>
    </CreatorProvider>
  );
};

export default CreatorApplication;
